import React, { useState } from 'react';
import {
  InputField,
  PasswordField,
  PhoneField,
  SelectField
} from '../../../utility/form/';
import LoadingButton from '../../../utility/button/LoadingButton';
import sectorOptions from './sectors.json';


import useRegister from './useRegister';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';  // example with react-i18next
import SEO from '../../../SEO/Seo';
import { metaContent } from '../../../SEO/metaContent';

const Register = () => {
  const { t } = useTranslation();
  const {
    form,
    onChange,
    onSubmit,
    loading,
    errors,
    step,
    setStep,
    validate,
    onCountryCodeChange
  } = useRegister();
  const navigate = useNavigate();

  return (<>
      {/* Meta tag */}
      <SEO {...metaContent.signup} />

    <div className="auth-card mx-auto">
      <h3 className="text-center fw-bold mb-1">{t('register.setupAccount')}</h3>
      <div
        className="text-center"
        style={{ color: '#7b7b8b', fontSize: '1rem', marginBottom: 20 }}
      >
        {t('register.personalizeExperience')}
      </div>
      <div
        className="d-flex justify-content-center align-items-center mb-4"
        style={{ borderBottom: '1px solid #ccc' }}
      >
        <div
          className="tab-inactive px-4 py-2"
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/signin')}
        >
          {t('login.signInTab')}
        </div>
        <div className="tab-active px-4 py-2" style={{ cursor: 'pointer' }}>
          {t('register.signUp')}
        </div>
      </div>

      <form onSubmit={onSubmit} noValidate>
        <>
          <div className="mb-2">
            <InputField
              label={t('register.email')}
              name="email"
              value={form.email}
              onChange={onChange}
              error={errors.email}
              placeholder={t('register.emailPlaceholder')}
              type="email"
            />
          </div>

          <div className="mb-4">
            <PhoneField
              label={t('register.phoneNumber')}
              type="tel"
              name="phone"
              value={form.phone}
              error={errors.phone}
              onChange={onChange}
              placeholder={t('register.phonePlaceholder')}
              isPhone={true}
              country_code={form.country_code}
              onCountryCodeChange={onCountryCodeChange}
            />
          </div>
          <div className="mb-2">
            <SelectField
              label={t('register.sector')}
              type="select"
              name="sector"
              value={form.sector}
              onChange={onChange}
              error={errors.sector}
              options={sectorOptions}
            />
          </div>

          <div className="mb-2">
            <PasswordField
              label={t('register.password')}
              name="password"
              value={form.password}
              onChange={onChange}
              error={errors.password}
              placeholder={t('register.passwordPlaceholder')}
              type="password"
            />
          </div>

          <div className="mb-4">
            <PasswordField
              label={t('register.confirmPassword')}
              name="password_confirmation"
              value={form.password_confirmation}
              onChange={onChange}
              error={errors.password_confirmation}
              placeholder={t('register.confirmPasswordPlaceholder')}
              type="password"
            />
          </div>
          <div className="mb-2">
            <InputField
              label={t('register.referalCode')}
              name="referral_code"
              value={form.referral_code}
              onChange={onChange}
              placeholder={t('register.referalCodePlaceholder')}
              type="text"
            />
          </div>

          <LoadingButton
            type="submit"
            disabled={loading}
            isLoading={loading}
            className="w-100"
          >
            {t('register.signUp')}
          </LoadingButton>
        </>
      </form>
    </div>
  </>
  );
};

export default Register;
